import { createContext, useContext, useEffect, useState } from "react";

const NavContext = createContext(null);

export function NavProvider({ children }) {
    const [collapsed, setCollapsed] = useState(() => {
        try { return localStorage.getItem("fm_sidebar_collapsed") === "1"; } catch { return false; }
    });
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        try { localStorage.setItem("fm_sidebar_collapsed", collapsed ? "1" : "0"); } catch (e) { void e; }
    }, [collapsed]);

    // Cierra mobile drawer al cambiar de ruta
    useEffect(() => {
        const close = () => setMobileOpen(false);
        window.addEventListener("popstate", close);
        return () => window.removeEventListener("popstate", close);
    }, []);

    return (
        <NavContext.Provider value={{ collapsed, setCollapsed, mobileOpen, setMobileOpen }}>
            {children}
        </NavContext.Provider>
    );
}

export const useNav = () => {
    const ctx = useContext(NavContext);
    if (!ctx) return { collapsed: false, setCollapsed: () => {}, mobileOpen: false, setMobileOpen: () => {} };
    return ctx;
};
